module.exports = ["dave_shworan","tim_burke","susan_foulds","nathan_coulson","james_moxley","steve_lang","manwinder_singh","devilliers","courtnie_croft","emily_hwang","doug_giebelhaus","don_murphy","tiffany_elliott","craig_shworan"]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/about/employees.json
// module id = HHUD
// module chunks = 0